import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Produto } from "./Types";
import { Avatar, Box, Button, Checkbox } from "@mui/material";

interface ProdutosProps {
  produtos: Produto[];
  className?: string;
  delivery_date?: string;
  payment_method?: string;
  onSelect?: () => void;
  orderId?: any;
  selectedId?: string;
  handleSelect?: (produto: Produto) => void;
  allowed_clique_retire?: string;
}

const Produtos: React.FC<ProdutosProps> = ({
  produtos,
  delivery_date,
  payment_method,
  selectedId: propSelectedId, // Rename the prop to avoid conflict
  allowed_clique_retire,
}) => {
  const [produtosSelecionados, setProdutosSelecionados] = useState<Produto[]>([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const navigate = useNavigate();

  const handleCheckboxChange = (produto: Produto) => {
    const isProductSelected = produtosSelecionados.some((p) => p.product_sold_id === produto.product_sold_id && p.variant_value === produto.variant_value);
    if (isProductSelected) {
      const updatedProdutos = produtosSelecionados.filter((p) => p.product_sold_id !== produto.product_sold_id || p.variant_value !== produto.variant_value);
      setProdutosSelecionados(updatedProdutos);
    } else {
      const produto2 = { ...produto, selectedId: propSelectedId };
      setProdutosSelecionados([...produtosSelecionados, produto2]);
    }
  };

  const handleConfirmar = () => {
    const dadosSelecionados = {
      delivery_date: delivery_date,
      payment_method: payment_method,
      allowed_clique_retire: allowed_clique_retire,
      selectedId: propSelectedId,
    };

    navigate("/products", {
      state: {
        payment_method,
        delivery_date,
        propSelectedId,
        produtosSelecionados,
        dadosSelecionados,
      },
    });
  };

  useEffect(() => {
    setIsButtonDisabled(produtosSelecionados.length === 0);
  }, [produtosSelecionados]);
  return (
    <>
      <Box display={"flex"} flexDirection={"column"} height={{ xs: 450, md: 300 }} overflow={"auto"} marginY={2}>
        {produtos.map((produto, index) => (
          <Box key={index} display={"flex"} p={2} borderBottom={"2px solid #f1f1f1"}>
            <Checkbox color="error" onClick={() => handleCheckboxChange(produto)} sx={{ borderRadius: 0 }} />
            <Avatar variant="rounded" src={produto.img} style={{ width: 100, height: 100 }} />
            <Box ml={1}>
              <p
                style={{
                  fontFamily: "Gotham",
                  fontSize: 21,
                  // letterSpacing: 2,
                  fontWeight: 400,
                  textOverflow: "ellipsis",
                  lineClamp: 1,
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: 1,
                  WebkitBoxOrient: "vertical",
                }}>
                {produto.name}
              </p>
              <p
                style={{
                  fontFamily: "Gotham",
                  fontWeight: 300,
                  letterSpacing: 1,
                }}>
                Variante: {produto.variant_value}
              </p>
              <p
                style={{
                  fontFamily: "Gotham",
                  fontWeight: 300,
                  letterSpacing: 1,
                }}>
                Quantidade: {produto.quantity}
              </p>
              <p
                style={{
                  fontFamily: "Gotham",
                  fontWeight: 400,
                  letterSpacing: 1,
                }}>
                {new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(produto.price))}
              </p>
            </Box>
          </Box>
        ))}
      </Box>

      <Button
        onClick={handleConfirmar}
        disabled={isButtonDisabled}
        variant="contained"
        sx={{
          width: "70%",
          borderRadius: 100,
          margin: "0 auto",
          display: "block",
          backgroundColor: "#221F20",
          "&:hover": {
            backgroundColor: "#908F8F",
            color: "#fff",
          },
        }}>
        Confirmar
      </Button>
    </>
  );
};

export default Produtos;
